import { useEffect } from 'react';

function findScrollableParent(el: Element | null): Element | null {
  let node: Element | null = el;
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const oy = style.overflowY;
    const canScroll =
      (oy === 'auto' || oy === 'scroll' || oy === 'overlay') &&
      node.scrollHeight > node.clientHeight + 1;
    if (canScroll) return node;
    node = node.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}

/**
 * Evita que la rueda del mouse cambie <input type="number"> con foco
 * (p. ej. 10 → 9.99) y reenvía el scroll al contenedor / página.
 */
export function usePreventNumberInputWheel(): void {
  useEffect(() => {
    const onWheel = (e: WheelEvent) => {
      const raw = e.target;
      if (!(raw instanceof Element)) return;

      const input =
        raw instanceof HTMLInputElement && raw.type === 'number'
          ? raw
          : (raw.closest('input[type="number"]') as HTMLInputElement | null);

      if (!input || document.activeElement !== input) return;

      e.preventDefault();

      const scroller = findScrollableParent(input.parentElement);
      if (scroller) {
        scroller.scrollTop += e.deltaY;
      } else {
        window.scrollBy(0, e.deltaY);
      }
    };

    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => {
      document.removeEventListener('wheel', onWheel, { capture: true });
    };
  }, []);
}
